/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getEntity = /* GraphQL */ `query GetEntity($siteId: String!, $type: String!, $entityId: String!) {
  getEntity(siteId: $siteId, type: $type, entityId: $entityId) {
    success
    message
    entity {
      ... on SUCCESS {
        id
        detail
        type
        shift
        department
        photo
        owner
        date
      }
      ... on SAFETY {
        id
        detail
        type
        shift
        department
        photo
        date
        ecd
        owner
      }
      ... on BARRIER {
        id
        detail
        type
        shift
        department
        photo
        owner
        process
        date
        ecd
        category
        modifyDate
        updateDetail
        progress
        priority
      }
      ... on PROJECT {
        id
        detail
        type
        shift
        department
        photo
        owner
        innovator
        process
        date
        ecd
        modifyDate
        updateDetail
        progress
        priority
      }
    }
    siteId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEntityQueryVariables, APITypes.GetEntityQuery>;
export const getEntities = /* GraphQL */ `query GetEntities(
  $siteId: String!
  $shift: String!
  $department: String!
  $type: String!
  $limit: Int
  $nextToken: String
) {
  getEntities(
    siteId: $siteId
    shift: $shift
    department: $department
    type: $type
    limit: $limit
    nextToken: $nextToken
  ) {
    success
    message
    entities {
      ... on SUCCESS {
        id
        detail
        type
        shift
        department
        photo
        owner
        date
      }
      ... on SAFETY {
        id
        detail
        type
        shift
        department
        photo
        date
        ecd
        owner
      }
      ... on BARRIER {
        id
        detail
        type
        shift
        department
        photo
        owner
        process
        date
        ecd
        category
        modifyDate
        updateDetail
        progress
        priority
      }
      ... on PROJECT {
        id
        detail
        type
        shift
        department
        photo
        owner
        innovator
        process
        date
        ecd
        modifyDate
        updateDetail
        progress
        priority
      }
    }
    siteId
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntitiesQueryVariables,
  APITypes.GetEntitiesQuery
>;
export const getEntitiesByDateRange = /* GraphQL */ `query GetEntitiesByDateRange(
  $siteId: String!
  $startDate: String!
  $endDate: String!
  $limit: Int
  $nextToken: String
) {
  getEntitiesByDateRange(
    siteId: $siteId
    startDate: $startDate
    endDate: $endDate
    limit: $limit
    nextToken: $nextToken
  ) {
    success
    message
    entities {
      ... on SUCCESS {
        id
        detail
        type
        shift
        department
        photo
        owner
        date
      }
      ... on SAFETY {
        id
        detail
        type
        shift
        department
        photo
        date
        ecd
        owner
      }
      ... on BARRIER {
        id
        detail
        type
        shift
        department
        photo
        owner
        process
        date
        ecd
        category
        modifyDate
        updateDetail
        progress
        priority
      }
      ... on PROJECT {
        id
        detail
        type
        shift
        department
        photo
        owner
        innovator
        process
        date
        ecd
        modifyDate
        updateDetail
        progress
        priority
      }
    }
    siteId
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntitiesByDateRangeQueryVariables,
  APITypes.GetEntitiesByDateRangeQuery
>;
